<template>
  <div>
    <template v-for="(resumeList, listIndex) in getStoreResumeList.list">
      <div class="talentList managementList" :key="listIndex + '&talentList'">

        <template v-for="(item, index) in resumeList.rec_resumes">

          <div class='list bg_fff cursor_p pr' data-growing-title='简历卡片' data-growing-container  :key="index + '&list'" @click="getDetail({item,index, listIndex})" v-if="!item.unsuitableCardState">
            
            <div class="newtop-content bg_fa f_14 color_9c">
              <!-- 顶部左侧  -->
              <div>
                <div class="flex">
              <div :class="['headImg pr', !userInfoState && index>=5 ? 'informationBlur' : '']" >
                <div class="pa img" :style="{backgroundImage:'url('+ (item.resume.info.profile.avatar_url || headImgList.round[item.resume.info.user_id%5]) +')',backgroundSize:'cover'}"></div>
                <div class="online-text" v-if="lastActiveAt(item.last_active_at)"><div  class="circle"></div>{{lastActiveAt(item.last_active_at)}}</div>
              </div>
              <div class="user-info">
                <div class="flex">
                  <!-- 用户名 -->
                  <div class="new-username">
                    <div class="name color_40 f_18 font_w_b pr fl" :class="[ !userInfoState ? 'informationBlur4' : '']">{{item.resume.info.profile.username}}</div>
                    <!-- <div class="onlineAt f_14 color_9c fl" v-if="lastActiveAt(item.last_active_at)" >{{lastActiveAt(item.last_active_at)}}</div> -->
                  </div>
                  <div class="leftItem color_40 f_14 beforeText" style="margin-bottom:10px">
                    <!-- 年纪 -->
                    <span class="display_ib" v-if="getAge(item.resume.info.profile.birthday)" >{{getAge(item.resume.info.profile.birthday)}}</span>
                    <!-- 性别 -->
                    <span class="display_ib" v-if="item.resume.info.profile.gender" >{{item.resume.info.profile.gender}}</span>
                    <!-- 工作年限/毕业时间 -->
                    <span class="display_ib" v-if="workingYears({profession_identity: item.profession_identity, years_of_work_experience:item.years_of_work_experience, graduate_at:item.resume.info.basic_info.graduate_at})" >{{workingYears({profession_identity: item.profession_identity, years_of_work_experience:item.years_of_work_experience, graduate_at:item.resume.info.basic_info.graduate_at})}}</span>
                    <!-- 最高学历 -->
                    <span class="display_ib" v-if="getDegreeName(item.resume.info, item.recent_edu_index)" >{{getDegreeName(item.resume.info, item.recent_edu_index)}}</span>
                  </div>
                </div>
                <div class="text beforeText fl color_40">
                  期望：
                  <span class="display_ib" v-if="(item.resume.info.basic_info.predicted_location && item.resume.info.basic_info.predicted_location.length) || (item.resume.info.basic_info.expected_location && item.resume.info.basic_info.expected_location.length)">{{item.resume.info.basic_info.expected_location.length ? item.resume.info.basic_info.expected_location.join('/') : item.resume.info.basic_info.predicted_location.join('/')}}</span>
                  <span class="display_ib" v-if="item.resume.info.profile.exp_job">{{item.resume.info.profile.exp_job}}</span>
                  <span class="display_ib" v-else-if="item.resume.info.basic_info.exp_job">{{item.resume.info.basic_info.exp_job}}</span>
                  <span class="display_ib">{{expected_salary(item.resume.info.profile.expected_salary) || expected_salary(item.resume.info.basic_info.expected_salary) || '面议'}}</span>
                </div>
                <!-- <div class="permissionState f_14 color_9c fr" v-if="!!item.hr_permission_state">{{item.hr_permission_state | hrPermissionState}}</div> -->
              </div>
                </div>
                <div class="highligt-body">
                  <div v-for="(sitem,index) in item.heighlightTags" :key="index + 'a' + item.cv_account_token"  class="highlight">{{sitem}}</div>
                  <div v-for="(sitem,index) in item.skillTags" :key="index + 'b' + item.cv_account_token"  class="skill-tags highlight">{{sitem}}</div>
                </div>
              </div>
              <div class="buttons_right">
                <el-tooltip v-if="
                  item.resume.contact_directly &&    
                  !(item.hr_permission_state==='rejected' || item.hr_permission_state==='passed') && 
                  !item.delivery_status &&
                  !(routePageName==='talentDelivery' || routePageName==='talentRefuseDelivery') &&  
                  !(routePageName==='talentMessage' && !messageOther)
                " class="item" effect="dark" content="该人才可直接获取电话" placement="top-end" >
                  <div :class="[
                    (item.resume.contact_directly &&    
                    !(item.hr_permission_state==='rejected' || item.hr_permission_state==='passed') && 
                    !item.delivery_status &&
                    !(routePageName==='talentDelivery' || routePageName==='talentRefuseDelivery') &&  
                    !(routePageName==='talentMessage' && !messageOther)) ? 'buttons' : 'buttons bg_60 color_9c disabled']" @click.stop="getPhone({item,index, listIndex})">
                    <span class="iconfont iconGroup311" ></span> 
                    <p>查看电话</p>
                  </div>
                </el-tooltip>
                <!-- 顶部右侧 -->
                <div class="standard-btn-content w200" >
                  <div class="standard-btn-left" v-if="(item.resume.contact_directly) && !item.hr_permission_state" @click.stop="resumeApply(item.hr_permission_state, JSON.parse(JSON.stringify(item)), {listIndex, index})">
                      <!-- <span class="iconfont iconGroup311" v-if="(item.resume.contact_directly) && !item.hr_permission_state"></span> -->
                    <!-- <i v-if="resumeApplyLoading" class="el-icon-loading"></i> -->
                    <template>{{!item.hr_permission_state && !item.delivery_status ? '打招呼' : '继续沟通'}}</template>
                  </div>
                  <div v-else class="standard-btn-left" @click.stop="resumeApply(item.hr_permission_state, JSON.parse(JSON.stringify(item)), {listIndex, index})">
                    <!-- <span class="iconfont iconGroup311" v-if="item.contact_directly && !item.hr_permission_state"></span> -->
                    <!-- <i v-if="resumeApplyLoading" class="el-icon-loading"></i> -->
                    <template>
                      {{!item.hr_permission_state && !item.delivery_status ? '打招呼' : '继续沟通'}}
                    </template>            
                  </div>
                  <div class="standard-btn-right" @click.stop="item.is_favorite ? changeCancelState(item) : resumeCollect(item,index,listIndex)">
                    <span class="iconfont pr" :class="[item.is_favorite ? 'iconfavoritesactive star color_ffc':'iconfavorites star color_40']"></span>
                    {{item.is_favorite?'移除储备':'储备'}}
                  </div>
                  <el-tooltip class="unsuitable color_40" effect="dark" content="不感兴趣" placement="top">
                    <div data-growing-container data-growing-idx="10" class="dislike" @click.stop="toggleUnsuitableState(listIndex, index, true)" >
                      <i class="iconfont color_40 iconrencaituijian-copy"></i>
                    </div>
                  </el-tooltip>
              
          
                </div> 
              </div>
              <!-- <div class="text beforeText fl">
                期望：
                <span class="display_ib" v-if="item.resume.info.basic_info.predict_cities && item.resume.info.basic_info.predict_cities.length">{{item.resume.info.basic_info.predict_cities.join('/')}}</span>
                <span class="display_ib" v-else-if="item.resume.info.basic_info.expected_cities && item.resume.info.basic_info.expected_cities.length">{{item.resume.info.basic_info.expected_cities.join('/')}}</span>
                <span class="display_ib" v-if="item.resume.info.profile.exp_job">{{item.resume.info.profile.exp_job}}</span>
                <span class="display_ib">{{expected_salary(item.resume.info.profile.expected_salary) || '面议'}}</span>
              </div> -->
              <!-- <el-tooltip  class="unsuitable iconfont iconcha color_9c text_center cursor_p" effect="dark" content="不感兴趣" placement="left">
                <div class="fr" v-if="!item.unsuited" @click.stop="handleClickUnsuitable(listIndex, index)"></div>
                <div data-growing-container data-growing-idx="10" class="fr" v-if="!item.unsuited" @click.stop="toggleUnsuitableState(listIndex, index, true)"></div>
              </el-tooltip> -->
            </div>

            <div class="userInfo flex new-content">
              <!-- 头像 -->
              <!-- <div :class="['headImg pr', !userInfoState ? 'informationBlur' : '']" >
                <div class="pa img" :style="{backgroundImage:'url('+ (item.resume.info.profile.avatar_url || headImgList.round[item.resume.user_id%5]) +')',backgroundSize:'cover'}"></div>
                <div class="gender pa iconfont" :class="[item.resume.info.profile.gender==='男'?'iconnan':'',item.resume.info.profile.gender==='女'?'iconnv':'',]"></div>
              </div> -->

              <!-- 中间内容区域 -->
              <div class="centerContent clearfix flex1 hasHighlightLength">
                <div class="fl flex" style="overflow: inherit; width: 100%;">
                  <!-- 工作经历 -->
                  <div class="work-list pr flex1">
                    <!-- 左侧分割线 -->
                    <div class="divid pa text_center color_fff">
                      <div class="start iconfont iconGroup32 pa"></div>
                    </div>

                    <div class="item" v-if="!(filterWork(item.resume.info.work_experiences).length + filterWork(item.resume.info.internship_experiences).length + item.resume.info.education_experiences.length)">
                      <div class="name f_14 color_40 beforeText">这位候选人还没有任何经历，快去看看其他候选人吧～</div>
                    </div>
                    <div class="item" v-else-if="!(filterWork(item.resume.info.work_experiences).length + filterWork(item.resume.info.internship_experiences).length)">
                      <div class="text f_12 color_9c beforeText mr48"> - </div>   
                      <div class="name f_14 color_40 beforeText">暂无工作经历</div>
                    </div>

                    <template v-else >
                      <!-- 有工作经历 -->
                      <template v-if="filterWork(item.resume.info.work_experiences).length">
                        <template v-for="(item,index) in filterWork(item.resume.info.work_experiences, item.keyword_hit)" >
                          <div class="item" :key="'work&' + index" v-if="index<2">
                            <div class="text f_12 color_9c beforeText mr48">
                              <span class="display_ib time" v-if="item.start_at||item.end_at || item.present">
                                <i v-if="item.start_at">{{splitTime(item.start_at)}}</i>
                                <i v-if="item.end_at || item.present">{{splitTime(item.end_at || item.present)}}</i>
                              </span>
                              <span class="display_ib">就职</span>
                              <span class="display_ib" v-if="getWorkTimeLength({start_at: item.start_at, end_at: item.end_at, present:item.present})">{{getWorkTimeLength({start_at: item.start_at, end_at: item.end_at, present:item.present})}}</span>
                            </div>
                            <div class="name f_14 color_40 beforeText ellipsis">
                              <span class="ellipsis" v-if="item.company_name" v-html="item.company_name"></span>
                              <span class="ellipsis" v-if="item.title" v-html="item.title"></span>
                            </div>
                          </div>
                        </template>
                      </template>
                      <!-- 实习经历 -->
                      <template v-if="filterWork(item.resume.info.work_experiences).length<2 && filterWork(item.resume.info.internship_experiences).length">
                        <template v-for="(sitem,sindex) in filterWork(item.resume.info.internship_experiences, item.keyword_hit)" >
                          <div class="item" :key="'internship&' + sindex" v-if="sindex < (filterWork(item.resume.info.work_experiences).length ? 1 : 2)">
                            <div class="text f_12 color_9c beforeText mr48">
                              <span class="display_ib time" v-if="sitem.start_at||sitem.end_at || sitem.present">
                                <i v-if="sitem.start_at">{{splitTime(sitem.start_at)}}</i>
                                <i v-if="sitem.end_at || sitem.present">{{splitTime(sitem.end_at || sitem.present)}}</i>
                              </span>
                              <span class="display_ib">实习</span>
                              <span class="display_ib" v-if="getWorkTimeLength({start_at: sitem.start_at, end_at: sitem.end_at, present:sitem.present})">{{getWorkTimeLength({start_at: sitem.start_at, end_at: sitem.end_at, present:sitem.present})}}</span>
                            </div>
                            <div class="name f_14 color_40 beforeText ellipsis">
                              <span class="ellipsis" v-if="sitem.company_name" v-html="sitem.company_name"></span>
                              <span class="ellipsis" v-if="sitem.title" v-html="sitem.title"></span>
                            </div>
                          </div>
                        </template>
                      </template>

                      <!-- 项目经历 -->
                      <template v-if="(filterWork(item.resume.info.work_experiences).length + filterWork(item.resume.info.internship_experiences).length)<2 && filterCustomSections(item.resume.info.project_experiences).length">
                        <template v-for="(sitem, sindex) in filterCustomSections(item.resume.info.project_experiences)" >
                          <div class="item" :key="'project_experiences&' + sindex" v-if="sindex<1">
                            <div class="text f_12 color_9c beforeText mr48">
                              <span class="display_ib time" v-if="sitem.start_at||sitem.end_at || sitem.present">
                                <i v-if="sitem.start_at">{{splitTime(sitem.start_at)}}</i>
                                <i v-if="sitem.end_at || sitem.present">{{splitTime(sitem.end_at || sitem.present)}}</i>
                              </span>
                              <span class="display_ib">项目</span>
                            </div>
                            <div class="name f_14 color_40 beforeText ellipsis">
                              <span class="ellipsis" v-if="sitem.name">{{sitem.name}}</span>
                              <span class="ellipsis" v-if="sitem.title">{{sitem.title}}</span>
                            </div>
                          </div>
                        </template>
                      </template>
                      <!-- 社团经历 -->
                      <template v-if="(filterWork(item.resume.info.work_experiences).length + filterWork(item.resume.info.internship_experiences).length)<2 && !filterCustomSections(item.resume.info.project_experiences).length && filterInfoSections(item.resume.info.orgs).length">
                        <template v-for="(sitem, sindex) in filterInfoSections(item.resume.info.orgs)" >
                          <div class="item" :key="'orgs&' + sindex" v-if="sindex<1">
                            <div class="text f_12 color_9c beforeText mr48">
                              <span class="display_ib time" v-if="sitem.start_at||sitem.end_at || sitem.present">
                                <i v-if="sitem.start_at">{{splitTime(sitem.start_at)}}</i>
                                <i v-if="sitem.end_at || sitem.present">{{splitTime(sitem.end_at || sitem.present)}}</i>
                              </span>
                              <span class="display_ib">社团</span>
                            </div>
                            <div class="name f_14 color_40 beforeText ellipsis">
                              <span class="ellipsis" v-if="sitem.name">{{sitem.name}}</span>
                              <span class="ellipsis" v-if="sitem.title">{{sitem.title}}</span>
                            </div>
                          </div>
                        </template>
                      </template>
                      <!-- 教育经历 -->
                      <template v-if="item.resume.info.education_experiences.length > 0" >
                        <template v-for="(sitem,sindex) in item.resume.info.education_experiences" >
                          <div class="item" v-if="sindex<2" :key="sindex">     
                            <div v-if="sindex == 0" class="divid-end text_center color_fff iconfont iconGroup12 pa"></div>
                            <div class="text f_12 color_9c mr48">
                              <span class="display_ib time" v-if="sitem.start_at">{{splitTime(sitem.start_at.split(' ')[0])}}</span> -  
                              <span v-if="sitem.end_at">{{splitTime(sitem.end_at.split(' ')[0])}}</span>
                            </div>
                            <div :class="[{splitnone: schoolTag(sitem.school.tag_names)},'name f_14 color_40 beforeText ellipsis']">
                              <span class="ellipsis" v-if="sitem.cust_uni_name || sitem.school.cn">{{sitem.cust_uni_name || sitem.school.cn}}</span>
                              <span class="ellipsis" v-if="sitem.cust_major_name || sitem.major_name.cn">{{sitem.cust_major_name || sitem.major_name.cn}}</span> 
                              <span v-if="sitem.cust_degree || sitem.degree_name.cn">{{sitem.cust_degree || sitem.degree_name.cn}}</span>
                              <span v-if="sitem.edu_type==='非全日制'" >非全日制</span>
                              <div class="schoolTag f_12 color_blue fl " v-if="schoolTag(sitem.school.tag_names)">{{schoolTag(sitem.school.tag_names)}}</div>
                            </div>
                          </div>
                        </template>
                      </template>
                    </template>
                  </div>

                </div>

              </div>
              <div v-if="!!item.hr_permission_state" :class="['invited-status','position_b_86',{'resove-status': item.hr_permission_state !== 'rejected' }]">{{ item.hr_permission_state === 'rejected' ? '邀约被拒' : (item.hr_permission_state === 'passed')  ? '已通过' : '待通过' }}</div>
            </div>
            <!-- 底部信息 -->
           <div v-if="jobTypeIsOnline" class="message clearfix color_40 f_14 expect-border">
              <div class="fl flex-box">根据  
                <!-- <img class="pr hot-job" src="https://files.wondercv.com/b-pc/fire.png" alt="" v-if="hotJobPro[jobInfo.profession_id] && jobInfo.job_post === item.job_post"> -->
                <img class="pr hot-job" src="https://files.wondercv.com/b-pc/fire.png" alt="" v-if="jobInfo.job_post === item.job_post">
                <!-- <p v-if="hotJobPro[jobInfo.profession_id] && jobInfo.job_post === item.job_post" class="hot-job-box"> -->
                <p v-if="jobInfo.job_post === item.job_post" class="hot-job-box">
                  <span class="hot-job-box">火爆职位</span>
                  「{{ item.job_post }}」
                </p>
                <p v-else>
                  {{ item.job_post }} 
                </p>
                推荐
              </div>
            <div class="fl col9c" v-if="item.job_status === 'draft'">(该职位尚未发布，发布后即可查看完整简历)</div>
            <!-- <div class="favorite f_14 color_40 cursor_p fr" @click.stop="resumeCollect(item, index, listIndex)"><span class="iconfont pr" :class="[item.is_favorite ? 'iconfavoritesactive current':'iconfavorites color_9c']"></span> {{item.is_favorite?'移除储备':'储备'}}</div> -->
            </div>
            <Group :key="index + 'a'" :currentResume="currentResume.resume" @close="()=>{showGroup=!showGroup}" v-if="currentResume && showGroup && item.resume.id == currentResume.resume.id"  :top="'88px'" :right="'32px'"></Group>
            <CancelCollection :currentResume="currentResume.resume" @close="()=>{showCancelCollection=!showCancelCollection}" @setGroup="setGroup" @cancel="resumeCollect(item,index,listIndex)" v-if="showCancelCollection && currentResume && item.resume.id == currentResume.resume.id"  :top="'88px'" :right="'75px'" />
          </div>

          <div class="unsuitableCard bg_fff" data-growing-title='简历卡片' data-growing-container  :key="index + '&unsuitableCard'" v-else>
            <div class="name f_14">
              <span class="color_blue iconfont iconjinggao"></span>
              <span class="color_40">告诉我们不感兴趣的原因，我们将为你推荐更合适的人才</span>
              <span class="colose fr color_9c_hover cursor_p" @click.stop="toggleUnsuitableState(listIndex, index, false)">撤销</span>
            </div>
            <div class="markValList clearfix f_14">
              <div class="tag fl color_9c cursor_p transition_2" v-for="sitem in markValList" :key="sitem.id + '&markValList'" @click="toggleMarkVal(sitem, listIndex, index)">{{sitem.label}}</div>
            </div>

          </div>
          
        </template>
      </div>
    </template>

    <!-- 申请简历弹窗 -->
    <resume-apply ref="resumeApplyRef" @hideResumeApply="hideResumeApply" v-if="showResumeApplyState" />
    <!-- 简历详情 -->
    <resume-detail-box ref="resumeDetailBox" @hideDetails="hideDetails" v-if="showDetail" @getDetail="getDetail" />
    <!-- 标记不合适 -->
    <unsuitable v-if="unsuitableData.showState" @hideDetails="hideDetails" />
    <!-- 绑定手机号弹窗 -->
    <bind-phone v-if="showBindPhone" @bindPhoneSuccess="bindPhoneSuccess" @closeBindPhone="closeBindPhone" />
    <!-- 完善信息弹层 -->
    <userinfo-tips />
     <!-- 购买查看电话次数弹窗 -->
<!--      <job-pay-dialog -->
<!--      v-if="showBuyPhoneState" -->
<!--      payType="bPhone" -->
<!--      :orderPriceText="1050" -->
<!--      type="phone" -->
<!--      title="查看电话" -->
<!--      subtitle="无需等待候选人同意邀约，直接查看联系方式，购买后无使用限制，用完即止"-->
<!--      @paidFunc="paidSuccFunc"-->
<!--      @closeFunc="closeBuyPhone"/>-->
      <!-- 未发布职位提示弹窗 -->
    <message-box
      v-if="showMessageBox"
      :pageData="messgaeBoxInfo"
      @cancelButton="showMessageBox=false"
      @close="showMessageBox=false"
      @confirmButton="$router.push({path:`/talent/jobedit/${jobInfo.token}`})"
    />
    <message-box
      v-if="showDirectMessageBox"
      :pageData="messageDirect"
      @cancelButton="showDirectMessageBox=false"
      @close="showDirectMessageBox=false"
      @confirmButton="toGreet"
    />
  </div>
</template>

<script>
//混入优化
import {mixinsUtils} from '@/mixins/search/utils';
// 所有接口
import actions from '@/actions'

import { checkUserState , get_tUser } from '@/utils/utils';
import { filterInfoSections, filterCustomSections, getAge, applied_at, getDegreeName, schoolTag, getWorkTimeLength } from '@/utils/resumeList';

import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
//申请简历
import ResumeApply from '@/components/block/ResumeApply'
//简历详情
import ResumeDetailBox from '@/components/resumeDetailBox'
import unsuitable from '@/components/delivery/Unsuitable'
//绑定手机号
import BindPhone from '@/components/bindPhone'

import userinfoTips from '@/components/block/userinfoTips'
import  hotJobPro  from '@/assets/js/constant.js'
// import JobPayDialog from '@/components/block/JobPayDialog'
import MessageBox from '@/components/block/MessageBox'
import Group from '@/components/collection/group.vue'
import CancelCollection from '@/components/collection/CancelCollection.vue'

export default {
  name: 'deliveryList',
  mixins: [mixinsUtils],
  props: {
    jobRecommend: {
      type: Object,
      default: () => {}
    },
    jobInfo:{
      type:Object,
      default: () => {}
    },
    jobTypeIsOnline:{
      type:Boolean,
      default:() => fasle
    }
  },
  // watch: {
  //   getStoreResumeList: {
  //     deep: true,
  //     handler: (newVal) => {
  //       console.log(newVal,"================>watchVal")
  //     }
  //   }
  // },
  data() {
    return {
      showMessageBox:false, //未发布职位提示弹窗
      messgaeBoxInfo:{     //未发布职位提示弹窗--描述文字
        desc:'',
        title:'请发布职位',
        confirmText:'立即发布',
        cancelText:'放弃',
        confirmButtonBg:'#FF6644'
      },
      showDirectMessageBox: false,  //首次直接直接邀约弹框
      messageDirect:{
        desc:'已使用默认打招呼语:「hr当前的默认打招呼雨」”向候选人发送邀约',
        title:'邀约成功',
        confirmText:'修改招呼语',
        cancelText:'放弃',
        confirmButtonBg:'#FF6644'
      },
      hotJobPro:hotJobPro.hotJobProfessionIds,
      // showResumeApplyState: false, //是否显示申请简历弹窗
      userJWT:{},
      showBindPhone: false, //是否显示绑定手机号弹窗
      bindData:{}, //账户绑定数据
      checkRequestState: { //接口请求状态
        resumeApply: false,
        downLoad: false,
      },
      showDetail: false,
      markValList: [{ //不合适原因
        id:0,
        label:'学历不符',
      },{
        id:1,
        label:'专业不符',
      },
        {
          id:2,
          label:'技能不符',
        },{
          id:3,
          label:'过往经历不符',
        },{
          id:4,
          label:'工作年限不符',
        }],
      recommendList: [],
      showGroup: false,  // 展示分组
      showCancelCollection: false,  // 展示取消收藏的弹窗
      currentResume: '', // 当前点击的简历卡片
      resumeApplyLoading: false  // 邀约防抖
    }
  },
  components: {
    ResumeApply,
    ResumeDetailBox,
    unsuitable,
    BindPhone,
    userinfoTips,
    // JobPayDialog,
    MessageBox,
    Group,
    CancelCollection
  },
  computed: {
    ...mapState('block', ['userInfoState', 'userinfoTipsState', 'showResumeApplyState', 'unsuitableData','getPhoneNumber','showBuyPhoneState']),
    ...mapState('delivery', ['deliveryList']),
    ...mapState('resumeDetails',['resumeDetail', 'myPosition', 'searchIndexObj','routePageName']),
    ...mapState('im',['hr_account_token']),
    ...mapGetters('resumeDetails',[ 'getStoreResumeList'] ),
  },
  created() {
    this.userJWT = get_tUser();
    // 获取用户绑定信息
    this.getUsersBind();
  },
  methods: {
    ...mapMutations('block', ['toggleUserInfoState', 'toggleUserinfoTips', 'toggleTipsType', 'updateBlockStateFun','updatePhoneNumberStateFun','updatePhoneNumberToken','updatePhoneNumber','updateDirectInvitation']),
    ...mapMutations('delivery', ['updateUnviewedJobDeliveriesCount', 'updateDeliveryListData']),
    ...mapMutations('resumeDetails', ['updateResumeDetail', 'updateResumeListObj', 'updateSearchIndexObj', 'updateResumeDetailState','updateResumeDetailToken','updateDownloadResumeInfo','updateListOptions', 'updateShowDetailFlag', 'updateSearchResumeBasic']),
    ...mapActions('resumeDetails',['getMyPosition', 'getRecommendResume']),
    ...mapMutations('userBindInfo', ['setBindInfo']),
    ...mapMutations('im',['updateSmallChatOpenId']),
    // 根据在线职位获取推荐简历
    // async getRecommend() {
    //   try {
    //     let res = await actions.resumes.getRecommend(this.dataParam)
    //     console.log(res,"==============>res")
    //     let { code, data: { resumes }, message } = res
    //     if (code === 1000) {
    //       this.recommendList = resumes
    //     } else {
    //       this.$message.error(message)
    //     }
    //   } catch (e) {
    //
    //   }
    // },
    changeCancelState(item) {
      this.showCancelCollection = true
      this.currentResume = item
    },
    // 首次邀约弹框更换打招呼语
    toGreet() {
      let {href} = this.$router.resolve({
        path: '/talent/greet'
      })
      window.open(href, '_blank')
    },
    // 移除储备时选择分组
    setGroup() {
      this.showGroup = true
    },
    //进入详情页
    async getDetail({item, index, listIndex}) {
      // 将列表简历的基本信息存入vuex
      this.updateSearchResumeBasic({item, recommend: true})
      this.updateDownloadResumeInfo(item)
      if(item.job_status === 'draft'){
        this.messgaeBoxInfo.desc = '发布'+item.job_post+'后，即可查看简历详情'
        this.showMessageBox = true
        return false
      }
      //显示弹层
      this.showDetail = true;
      this.updateShowDetailFlag(true)
      //检查是否完善信息，及更换用户
      const checkUser = await checkUserState({
        //不是hr
        callback1: () => {
          this.$router.replace({name: 'talentRecommend'});
          return false;
        },
        callback2: () => {
          //列表回到第一页，刷新数据
          location.reload();
          return false;
        },
      });
      // 更新搜索主页参数
      this.updateSearchIndexObj({
        listIndex,
        itemIndex: index,
      });

      //更改未读状态
      // this.toggleViewed(listIndex, index);

      let token = item.resume.token;

      // if(this.userJWT.h_t){
      //   //获取职位列表
      //   this.getMyPosition();
      // }

      //更新页面数据
      this.updateResumeDetail(item);
      actions.hr_accounts.postResumesActivities({
        token:token,
        acts: ['viewed'],
        job_id: item.job_id
      })
      //简历详情相关url 及 参数，用作收藏等交互
      // this.updateResumeDetailToken(options.token);

      
      // 高亮处理
      console.log(this.$refs.resumeDetailBox);
      this.$refs.resumeDetailBox && this.$refs.resumeDetailBox.highlightFunc()
    },

    //收藏/取消收藏
    async resumeCollect(item, index, listIndex) {
      //检查职位是否已发布
      if(item.job_status === 'draft'){
        this.messgaeBoxInfo.desc = '发布'+item.job_post+'后，即可取消收藏'
        this.showMessageBox = true
        return false
      }
      //检查是否完善信息，及更换用户
      const checkUser = await checkUserState({
        //不是hr
        callback1: () => {
          this.$router.replace({name: 'talentSearchIndex'});
          return false;
        },
        callback2: () => {
          //列表回到第一页，刷新数据
          location.reload();
          return false;
        },
      });
      //引导用户完善信息弹层
      if (!this.userInfoState) {
        //更新是否完善信息(状态库)
        let userInfo = await actions.hr_accounts.getUserinfo();
        this.toggleUserInfoState(userInfo)
        if (!this.userInfoState) {
          //提示
          this.toggleUserinfoTips(true);
          return false;
        }
      }
      //更改未读状态
      // this.toggleViewed(listIndex, index);

      let token = item.resume.token;
      let is_favorite = item.is_favorite;
      let data = {
        token,
        job_id: item.resume.job_id,
        type: is_favorite ? 'dislike' : 'like'
      }

      // b向c发送通知
      if(!is_favorite && item.resume.cv_account_token){
        actions.im.sendNotifications({
          type: 'collect',
          cv_account_token: item.resume.cv_account_token,
          app_push: true,
          wechat_message: true
        })
      }
      // 储备
      let flag = true
      if(!is_favorite){
        let res = await actions.favorites.favorites_add_group({token, job_id: item.resume.job_id})
          if(res.code == 1000) {
            this.$message.success('已储备至默认分组')
            this.currentResume = item
            this.showGroup = true
          } else {
            this.$message.error(res.message)
            flag = false
          }
      } else {
        let ress = await actions.favorites.favorites_chancle_group({token, job_id: item.resume.job_id})
          if(ress.code == 1000) {
            this.$message.success('移除成功')     
          } else {
            this.$message.error(ress.message)
            flag = false
          }
      }
      if(flag && index >-1) {
        //更改列表收藏状态
        let getStoreResumeList = JSON.parse(JSON.stringify(this.getStoreResumeList.list));
        getStoreResumeList[listIndex].rec_resumes[index].is_favorite = item.is_favorite ? false : true;
        this.updateResumeListObj({key:'recommend', value: getStoreResumeList[0].rec_resumes});
      }
    },
    //返回 满足条件的内容【有公司名称】
    checkWork(work_experiences) {
      let html = '';
      let workIndex = -1;
      work_experiences && work_experiences.forEach((item, index) => {
        if (item.company_name && workIndex < 0) {
          workIndex = index;
        }
      });
      if (workIndex > -1) {
        html += `<span class="ellipsis d-i-b max70">${work_experiences[workIndex].company_name}</span>`
        if (work_experiences[workIndex].title) {
          html += `<span class="flex1 ellipsis">${work_experiences[workIndex].title}</span>`
        }
      }
      return html
    },
    //返回 满足条件的内容【有学校名称】
    checkEdu(education_experiences, lang) {
      let html = '';
      let eduIndex = -1;
      education_experiences && education_experiences.forEach((item, index) => {
        if ((item.cust_uni_name || item.school[lang]) && eduIndex < 0) {
          eduIndex = index;
        }
      });
      if (eduIndex > -1) {
        html += `<span>${education_experiences[eduIndex].cust_uni_name || education_experiences[eduIndex].school[lang]}</span>`
        if (education_experiences[eduIndex].cust_major_name || education_experiences[eduIndex].major_name[lang]) {
          html += `<span>${education_experiences[eduIndex].cust_major_name || education_experiences[eduIndex].major_name[lang]}</span>`
        }
        if (education_experiences[eduIndex].cust_degree || education_experiences[eduIndex].degree_name[lang]) {
          html += `<span>${education_experiences[eduIndex].cust_degree || education_experiences[eduIndex].degree_name[lang]}</span>`
        }
      }
      if (html.length) {
        html = "<div class='afterText' style='width:100%;'>" + html
        html += "</div>"
      }
      return html
    },
    //过滤空公司信息
    filterWork(work_experiences, keyword_hit = []) {
      if (!work_experiences) {
        return []
      }
      let workList = []
      work_experiences = JSON.parse(JSON.stringify(work_experiences));
      work_experiences.forEach(item => {
        if (item.company_name || (item.resume && item.resume.title)) {
          workList.push(item)
        }
      })
      return workList;
    },
    //更改未读状态
    toggleViewed(listIndex, index) {
      let getStoreResumeList = JSON.parse(JSON.stringify(this.getStoreResumeList.list));
      let item = getStoreResumeList[listIndex].rec_resumes[index];
      if (item.unsuited) {
        return false;
      }
      item.unsuited = true;
      this.updateResumeListObj({key:'recommend', value: getStoreResumeList[0].rec_resumes});

    },

    //不感兴趣
    handleClickUnsuitable(listIndex, itemIndex) {
      // 更新搜索主页参数
      this.updateSearchIndexObj({
        listIndex,
        itemIndex,
      });
      this.updateBlockStateFun({
        type:'unsuitableData',
        value: {
          showState: true, //是否展示不合适弹窗
          index: -1, //不合适index
        }
      })
    },
    // 取消邀约时恢复邀约状态
    hideResumeApply() {

    },
    //发送邀约
    async resumeApply(state, item, {listIndex, index}) {
      //检查职位是否已发布
      if(item.job_status === 'draft'){
        this.messgaeBoxInfo.desc = '发布'+item.job_post+'后，即可发送邀约'
        this.showMessageBox = true
        return false
      }
      //检查是否完善信息，及更换用户
      const checkUser = await checkUserState({
        //不是hr
        callback1: () => {
          // this.$router.replace({name:'talentSearchIndex'});
          // return false;
        },
        callback2: () => {
          //列表回到第一页，刷新数据
          location.reload();
          return false;
        },
      });

      //引导用户完善信息弹层
      if (!this.userInfoState) {
        if(this.userJWT.h_t){
          //更新是否完善信息(状态库)
          let userInfo = await actions.hr_accounts.getUserinfo();
          this.toggleUserInfoState(userInfo)
        }
        if (!this.userInfoState) {
          //提示
          this.toggleUserinfoTips(true)
          return false;
        }
      }
      // 检查是否是继续沟通
      if(state){
        let { cv_account_token } = item.resume;
        if(!cv_account_token){
          this.$message({
            message: '对方身份状态异常，无法创建聊天',
            type: 'success'
          });
          return
        }
        let data = {
          b_token: this.hr_account_token,
          c_token: cv_account_token,
          identity: item.delivery_status ? 'c' : 'b'
        }
        actions.im.post_relationships(data).then(async res=>{
          if(res.code === 1000){
            // 恢复隐藏好友状态
            try {
              await actions.im.putRelationshipsHide({
                b_token: this.hr_account_token, //用户token,
                c_token: cv_account_token, //被曝光的关系id
                b_hide: false, //是否隐藏联系人
              })
            } catch (error) { }
            setTimeout(() => {
              this.updateSmallChatOpenId(cv_account_token)
              // window.open(`${window.location.origin}/talent/chat?chat_id=${cv_account_token}`)
              // this.$router.push({path:'/talent/chat', query:{ chat_id: cv_account_token}})
            }, 300);
          }
        })
        return
      }

      // 检查是否已经邀约过
      // if (state === 'applied') {
      //   this.$message({
      //     message: '人才已收到邀约！继续联系更多人才获得回复率更高哦~',
      //     type: 'warning'
      //   });
      //   return false;
      // }

      // 更新搜索主页参数
      this.updateSearchIndexObj({
        listIndex,
        itemIndex: index,
      });



      // if (index > -1) {
      //   this.updateResumeDetailState({
      //     pageName: 'talentRecommend',
      //     stateType: 'hr_permission_state',
      //     stateIndex: this.searchIndexObj.itemIndex,
      //     value: 'applied',
      //   })
      // }

      if (!this.showResumeApplyState && !this.resumeApplyLoading) {
        this.resumeApplyLoading = true
        //更新职位列表
        try {
          await this.getMyPosition()
        } catch (error) {}
        if (!this.myPosition.list.length) {
          //提示
          this.toggleUserinfoTips(true)
          //更新信息弹层 提示文案类型
          this.toggleTipsType(2)
          return false;
        }
        // 检查是否绑定手机号
        if(!this.bindData.phone_is_bound){
          this.showBindPhone = true
          return
        }
        //切换展示简历邀约样式
        // this.updateBlockStateFun({type: 'showResumeApplyState', value: true})
        let isFirstShow = localStorage.getItem('showFirstSayHello')
        this.updateDirectInvitation(true)
        this.updateBlockStateFun({type: 'showResumeApplyState', value: true})
        // 首次使用打招呼
        if(!isFirstShow) {
          localStorage.setItem('showFirstSayHello', true) 
          let res = await actions.im.getGreetings({ user_token: this.userJWT.h_t })
          setTimeout(async () => {
            if(res.code === 1000) {
              let { b_content, b_current_index } = res.data
              this.showDirectMessageBox = true
              this.messageDirect.desc = `已使用默认打招呼语:「${b_content[b_current_index]}」”向候选人发送邀约`
              this.$refs.resumeApplyRef && this.$refs.resumeApplyRef.resumeApplyCallBack()
            }
          },50)
        } else {
          setTimeout(()=>{
            this.$refs.resumeApplyRef && this.$refs.resumeApplyRef.resumeApplyCallBack()
          },50)
        }
        this.resumeApplyLoading = false
        return false;
      }

    },
    //【详情】隐藏详情
    hideDetails(){
      this.showDetail = false;
      //重置详情的token相关数据
      // this.updateResumeDetailToken('');
      document.body.style.position = 'initial'
      document.body.style.overflow = 'initial'
    },

    //切换数据不感兴趣卡片状态
    toggleUnsuitableState(listIndex, index, state){
      let getStoreResumeList = JSON.parse(JSON.stringify(this.getStoreResumeList.list));
      getStoreResumeList[listIndex].rec_resumes[index].unsuitableCardState = state;
      //检查职位是否已发布
      if(getStoreResumeList[listIndex].rec_resumes[index].job_status === 'draft'){
        this.messgaeBoxInfo.desc = '发布'+getStoreResumeList[listIndex].rec_resumes[index].job_post+'后，即可标记'
        this.showMessageBox = true
        return false
      }
      this.updateResumeListObj({key:'recommend', value: getStoreResumeList[0].rec_resumes});
    },
    //点击不合适
    toggleMarkVal(sitem, listIndex, itemIndex){
      let getStoreResumeList = JSON.parse(JSON.stringify(this.getStoreResumeList));
      //走同步接口
      let unsuited_reason = [sitem.id];
      let item = getStoreResumeList.list[listIndex].rec_resumes[itemIndex];

      let data = {
        type:'unsuited',
        unsuited_reason:unsuited_reason.join(','),
        way: 'recommend',
        platform: 'pc_browser',
        job_id: item.job_id || ''
      }

      // 提交不合适
      actions.resumes.putRecommendations(item.resume.token, data).then(res=>{
        if(res.code===1000){

          if(this.getStoreResumeList.list[listIndex].rec_resumes.length === 1){
            // this.$emit('jobRecommendChange', {item: '',index: 0})
          }else{
            getStoreResumeList.list[listIndex].rec_resumes.splice(itemIndex, 1);
            this.updateResumeListObj({key: getStoreResumeList.listName, value: getStoreResumeList.list[0].rec_resumes});
          }

        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      });

      //更改未读数量
      this.updateUnviewedJobDeliveriesCount();
    },
    //获取用户绑定信息
    getUsersBind(){
      actions.auth.getUserBind(this.userJWT.t).then(res=>{
        if(res.code === 1000){
          this.bindData = res.data;
          this.setBindInfo(this.bindData)
        }
      })
    },
    //手机号绑定成功回调
    bindPhoneSuccess(){
      //重新获取用户绑定信息
      this.getUsersBind();
      this.showBindPhone = false;
    },
    // 关闭绑定手机号
    closeBindPhone(){
      this.showBindPhone = false;
    },
    async getPhone({item, index, listIndex}){
      //检查职位是否已发布
      if(item.job_status === 'draft'){
        this.messgaeBoxInfo.desc = '发布'+item.job_post+'后，即可查看联系方式'
        this.showMessageBox = true
        return false
      }
      if(!(item.getPhoneState  || ( item.hr_permission_state==='rejected' || item.hr_permission_state==='passed'))){
        let res = await actions.job_deliveries.get_phone_times({});
        if(res.code === 1000){
          // this.updatePhoneNumber(res.data.check_contact_count )
          this.updatePhoneNumber(res.data.count)
        }else{
          this.updatePhoneNumber(0)
        }
        if(this.getPhoneNumber < 1){
          let params = {
            plan: 'view_phone_30',
          }
          let res = await actions.recruit_infos.create_order(params)
          if(res.code === 1000){
            this.updatePhoneNumberToken(res.data.order_token)
            this.updatePhoneNumberStateFun(true)
          }
        }else{
          this.toggleUserinfoTips(true);
          //更新信息弹层 提示文案类型
          this.toggleTipsType(3)
          // 更新搜索主页参数
          this.updateSearchIndexObj({
            listIndex,
            itemIndex: index,
          });
          this.updateResumeDetailToken(item.resume.token)
          //更新页面数据
          this.updateResumeDetail(item);
        }
      }
    },
    // closeBuyPhone(){
    //   this.updatePhoneNumberToken('')
    //   this.updatePhoneNumberStateFun(false)
    // },
    // paidSuccFunc(){
    //   this.updatePhoneNumberToken('')
    //   this.updatePhoneNumberStateFun(false)
    // },

    filterInfoSections, //过滤模块
    filterCustomSections, //获取自定义模块数据
    getAge, //获取年龄
    applied_at, //时间
    getDegreeName, //获取专业名称
    schoolTag,
    getWorkTimeLength,

  },
  filters: {
    formatDate: function (value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM;
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h;
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m;
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m;
    },
  }
}
</script>

<style lang="scss" scoped>

@import '@/assets/css/components/resumeList.scss';

@import './Index.scss';
/deep/ .beforeText > span:before{
  color: #CFCFCF;
  bottom: 1px;
}
.col9c{
  color: #9C9C9C;
}
.flex-box{
  display: flex;
  align-items: center;
  .hot-job{
    display: block;
    width: 15px;
    height: 15px;
    margin: 0 5px 0 10px;
  }
}
.hot-job-box{
  font-weight: 600;
}
</style>